import { FC } from "react";
import { COLORS } from "shared/consts";

type PositionIconProps = {
  fill?: string;
  width?: number | string;
  height?: number | string;
  className?: string;
};

export const PositionIcon: FC<PositionIconProps> = ({
  fill = COLORS.FG.DEFAULT,
  width = 24,
  height = 24,
  className,
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.3333 1.25H10.8333V0H13.3333C14.2538 0 15 0.746192 15 1.66667V4.16667H13.75V1.66667C13.75 1.43655 13.5635 1.25 13.3333 1.25ZM4.16667 0V1.25H1.66667C1.43655 1.25 1.25 1.43655 1.25 1.66667V4.16667H0V1.66667C0 0.746192 0.746192 0 1.66667 0H4.16667ZM0 10.8333H1.25V13.3333C1.25 13.5635 1.43655 13.75 1.66667 13.75H4.16667V15H1.66667C0.746192 15 0 14.2538 0 13.3333V10.8333ZM10.8333 15V13.75H13.3333C13.5635 13.75 13.75 13.5635 13.75 13.3333V10.8333H15V13.3333C15 14.2538 14.2538 15 13.3333 15H10.8333ZM7.73608 3.40958L7.50014 3.3134L7.26421 3.40958L3.7224 4.85342L3.33333 5.01203V5.43218V9.57983V10.0024L3.72545 10.1598L7.26711 11.5819L7.49999 11.6754L7.73287 11.5819L11.2748 10.1598L11.667 10.0024V9.57983V5.43218V5.01203L11.2779 4.85342L7.73608 3.40958ZM4.58333 6.84523V9.15729L6.875 10.0775V7.7902L4.58333 6.84523ZM10.417 9.15728L8.125 10.0775V7.79032L10.417 6.84523V9.15728ZM9.97891 5.67376L7.50014 4.66327L5.02138 5.67376L7.50014 6.69588L9.97891 5.67376Z"
        fill={fill}
      />
    </svg>
  );
};

